export default __webpack_public_path__ + "static/media/minus-icon.e83ca49b.svg";